module.exports = {
  el: '#cnode',
  data: {
    params: {
      tab: '',
      topicId: '',
      page: 0
    }
  },
  components: {
    'article': require('./components/article.vue'),
    'menu': require('./components/menu.vue'),
    'topic-list': require('./components/topic-list.vue')
  }
}


/** WEBPACK FOOTER **
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/app.vue
 **/